import React, { Fragment } from 'react';
import {
    Select,
    SelectTrigger,
    SelectValue,
    SelectContent
} from './select';
import { MenuItem } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Checkbox } from './checkbox';
import { Chip } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { cn } from 'src/lib/utils';

const MultiSelectInputDisable = ({ onValueChange, value = [], options = [], rules, errors, placeholder, className, name = '', control, label, required, defaultValue = [] }) => {

    const handleCheckboxChange = (event, selectedValue) => {
        event.preventDefault();
        const newValue = value.includes(selectedValue)
            ? value.filter(val => val !== selectedValue)
            : [...value, selectedValue];
        onValueChange(newValue, name);
    };

    const handleMenuItemClick = (event, itemValue) => {
        event.stopPropagation();
        handleCheckboxChange(event, itemValue);
    };

    // const handleSelectAll = (event) => {
    //     event.stopPropagation();
    //     const allValues = options?.map(option => option.value);
    //     onValueChange(allValues, name);
    // };

    const handleSelectAll = (event) => {
        event.stopPropagation();
        const allSelectableValues = options?.map(option => option.value);
    
        if (value.length === allSelectableValues.length) {
            // If all options are already selected, clear all
            onValueChange(options?.filter((filterData, _) => filterData?.disable)?.map((mapData, _) => mapData?.id), name);
        } else {
            // Otherwise, select all
            onValueChange(allSelectableValues, name);
        }
    };

    const handleRemoveItem = (itemValue) => {
        const newValue = value.filter(val => val !== itemValue);
        onValueChange(newValue, name);
    };

    const renderSelectedItems = (selected) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                {selected.map((selectedValue, index) => {
                    const selectedItem = options.find(option => option.value === selectedValue);
                    return selectedItem ? (
                        <Chip
                            sx={{ height: '30%', borderRadius: '3px', backgroundColor: 'hsl(var(--primary-foreground))', color: 'hsl(var(--primary))' }}
                            key={index}
                            label={selectedItem.label}
                            onDelete={() => handleRemoveItem(selectedValue)}
                            deleteIcon={<IoClose style={{ display: 'none' }} color='hsl(var(--primary-foreground))' size={15} />}
                            onMouseDown={(event) => event.stopPropagation()}
                        />
                    ) : null;
                })}
            </div>
        );
    };

    return (
        <Fragment>
            {label && <label className='grc-label block mb-1'>{label}{required && <span className='text-danger'>*</span>}</label>}
            <Controller
                defaultValue={defaultValue}
                name={name}
                control={control}
                rules={rules}
                render={({ field: { onChange } }) => (
                    <Select
                        key={name}
                        onValueChange={e => { onValueChange(e, name); onChange(e); }}
                        value={value}
                        defaultValue={defaultValue}
                        multiple
                    >
                        <SelectTrigger className={'input-grc select-trigger ' + className}>
                            <SelectValue placeholder={placeholder}>
                                {value?.length > 0 ? renderSelectedItems(value) : <span style={{ color: 'hsl(var(--border))' }}>{placeholder}</span>}
                            </SelectValue>
                        </SelectTrigger>
                        <SelectContent>
                            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                <MenuItem sx={{ borderBottom: '1px solid hsl(var(--border))' }} onClick={handleSelectAll}>
                                    <Checkbox className='mr-2' checked={value.length === options?.length} />
                                    <span>Select All</span>
                                </MenuItem>
                                {options?.map((item, index) => {
                                    return (
                                        <MenuItem
                                            value={item.value}
                                            key={index}
                                            disabled={item?.disable}
                                            onClick={(event) => handleMenuItemClick(event, item?.value)}
                                        >
                                            <Checkbox
                                                className={cn(item?.disable ? 'pointer-events-none' : '', 'mr-2')}
                                                color={item?.disable && 'hsl(var(--grey))'}
                                                checked={value?.includes(item?.value)}
                                                disabled={item?.disable}
                                                onChange={(event) => handleCheckboxChange(event, item?.value)}
                                            />
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                            </div>
                            <div
                                style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    backgroundColor: 'white',
                                    borderTop: '1px solid hsl(var(--border))',
                                    textAlign: 'center',
                                }}
                            >
                                <button
                                    className="clear-all-button"
                                    style={{
                                        color: 'hsl(var(--primary))',
                                        cursor: 'pointer',
                                        padding: '4px 8px',
                                        background: 'none',
                                        border: 'none',
                                    }}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onValueChange(options?.filter((filterData, _) => filterData?.disable)?.map((mapData, _) => mapData?.id), name); // Clear the value
                                    }}
                                >
                                    Clear All
                                </button>
                            </div>
                        </SelectContent>

                    </Select>
                )}
            />
            <p className='grc-error-msg text-danger'>{errors && name && errors[name]?.message}</p>
        </Fragment>
    );
};

MultiSelectInputDisable.propTypes = {
    className: PropTypes.string,
    value: PropTypes.array,
    onValueChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errors: PropTypes.any,
    rules: PropTypes.object,
    control: PropTypes.any,
    message: PropTypes.any,
    required: PropTypes.bool,
    options: PropTypes.array,
    defaultValue: PropTypes.array
};

export default MultiSelectInputDisable;
